<template>
    <div class="row">
        <button class="btn btn-primary ml-2" @click="view(items)" data-toggle="modal" :data-target="'#vmbc'+items.id"><i class="fa fa-eye"></i></button>

        <div :id="'vmbc'+items.id" class="modal fade" role="dialog">
            <div class="modal-dialog modal-lg">

                <!-- Modal content-->
                <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">STEP - {{items.id}} </h4>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">

                    <table class="table table-bordered table-condensed">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Quantity</th>
                                <th>Notes</th>
                                <th>Discount</th>
                                <th>VAT 5%</th>
                                <th>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="product in products" :key="product.id">
                                <td> {{product.productname}} - <small>{{product.productoption}}</small> <p v-if="product.name !== null"> {{product.student}} </p> </td>
                                <td> {{product.quantity}} </td>
                                <td> {{product.notes}} </td>
                                <td> {{product.discount}} </td>
                                <td> {{product.vat}} </td>
                                <td> {{product.total}} </td>
                            </tr>
                        </tbody>
                    </table>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                </div>
                </div>

            </div>
        </div>

    </div>
</template>
<script>
export default {
    props: ['items'],
    data() {
        return {
            products: [],
        }
    },
    methods: {
        view(items) {
        axios
        .post('./api/Report/Payment-Report/options', {
            category: items.category,
            id: items.id
        })
        .then((result) => {
            console.log(result)
            this.products = result.data.products
        }).catch((err) => {
            console.log(err)
        });
    }
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/Report/Report/PaymentOptions.vue